import * as React from "react";
const SvgFiRrHandBackPointDown = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M9.005 24A3 3 0 0 1 6 21l.02-7.274-3.945-3.919A3.62 3.62 0 0 1 1 7.231a3.62 3.62 0 0 1 1.066-2.579l2.308-2.308A7.94 7.94 0 0 1 10.031 0H17c2.757 0 5 2.243 5 5v4.721a5.01 5.01 0 0 1-4.019 4.903L12 15.82v5.073c0 1.516-1.076 2.834-2.503 3.066a3 3 0 0 1-.492.041M7.039 6h.003a1 1 0 0 1 .997 1.003l-.039 14c0 .291.128.569.353.759.228.193.522.272.823.224.462-.076.825-.556.825-1.093V15c0-.477.336-.887.804-.98l6.785-1.357a3.01 3.01 0 0 0 2.412-2.942V5c0-1.654-1.346-3-3-3h-6.969c-1.603 0-3.11.624-4.243 1.757L3.482 6.065a1.63 1.63 0 0 0-.48 1.162c0 .439.172.851.484 1.161l2.544 2.527.011-3.917a1 1 0 0 1 1-.997z"
    />
  </svg>
);
export default SvgFiRrHandBackPointDown;
